import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }

import DatePicker from '@/components/Common/DatePicker.vue';
import i18n from '@/lang/i18n';
import { computed } from "vue";
import UnexpectedEventFileType from '@/types/UnexpectedEventFile'
import RegisteredFile from '@/components/DailyReportUpdateModalParts/UnexpectedEventShowRegisteredFile.vue';

const MAX_REGISTER_FILE_LENGTH = 5


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventRegisterContent',
  props: {
    modelValue: {},
    registeredFiles: {},
    errors: {},
    deleteRegisteredFile: { type: Function },
    downloadFile: { type: Function },
    isDownloadings: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const totalTime = computed(() => {
  const endTime = new Date(modelValue.value.end_time)
  const startTime = new Date(modelValue.value.start_time)
  const diffMiliSeconds = endTime.getTime() - startTime.getTime()

  const minuts = Math.floor(diffMiliSeconds / 1000 / 60) % 60
  const hours = Math.floor(diffMiliSeconds / 1000 / 60 / 60)
  return i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.times', { hours: hours, minuts: minuts})
})

const safeFiles = computed(() => {
  return Array.isArray(modelValue.value.files) ? modelValue.value.files : []
})

const inputFileLength = computed(() => {
  if(props.registeredFiles.length) {
    if(props.registeredFiles.length == MAX_REGISTER_FILE_LENGTH) return 0
  }
  return safeFiles.value.length
})

const isDisplayAddButton = computed(() => {
  const totalLenfth = props.registeredFiles.length + safeFiles.value.length
  return totalLenfth < MAX_REGISTER_FILE_LENGTH
})

function addColumn() {
  if (!Array.isArray(modelValue.value.files)) {
    modelValue.value.files = []
  }
  modelValue.value.files.push([])
}

function fileDelete(index: number) {
  if (!Array.isArray(modelValue.value.files)) {
    modelValue.value.files = []
    return
  }
  if (modelValue.value.files.length == 1) {
    return modelValue.value.files[0] = []
  }
  modelValue.value.files.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(DatePicker, {
              modelValue: modelValue.value.start_time,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.start_time) = $event)),
              label: _unref(i18n).global.t('pages.dailyReports.unexpectedEventRegisterModal.startTime'),
              required: true,
              errors: props.errors.start_time
            }, null, 8, ["modelValue", "label", "errors"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(DatePicker, {
              modelValue: modelValue.value.end_time,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.end_time) = $event)),
              label: _unref(i18n).global.t('pages.dailyReports.unexpectedEventRegisterModal.endTime'),
              required: true,
              errors: props.errors.end_time
            }, null, 8, ["modelValue", "label", "errors"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventRegisterModal.totalTime')), 1),
            _createVNode(_component_v_text_field, {
              variant: "underlined",
              modelValue: totalTime.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((totalTime).value = $event)),
              readonly: "",
              density: "compact",
              "hide-details": "auto",
              clearable: false
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "py-1 mt-2" }, {
          default: _withCtx(() => [
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventRegisterModal.address')) + " ", 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
            ]),
            _createVNode(_component_v_text_field, {
              modelValue: modelValue.value.address,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.address) = $event)),
              density: "compact",
              "hide-details": "auto",
              maxlength: "100",
              class: "mt-2",
              "error-messages": props.errors.address
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventRegisterModal.note')) + " ", 1),
              _cache[6] || (_cache[6] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
            ]),
            _createVNode(_component_v_textarea, {
              modelValue: modelValue.value.note,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.note) = $event)),
              density: "compact",
              "hide-details": "auto",
              maxlength: "300",
              class: "mt-2",
              "error-messages": props.errors.note
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventRegisterModal.documents')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputFileLength.value, (number, i) => {
              return (_openBlock(), _createBlock(_component_v_row, { key: number }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_file_input, {
                        modelValue: modelValue.value.files[i],
                        "onUpdate:modelValue": ($event: any) => ((modelValue.value.files[i]) = $event),
                        "error-messages": props.errors[`files.${i}`]
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "red",
                        rounded: "xl",
                        variant: "text",
                        onClick: ($event: any) => (fileDelete(i))
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.registeredFiles, (file, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                file
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "7" }, {
                          default: _withCtx(() => [
                            _createVNode(RegisteredFile, { file: file }, null, 8, ["file"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "3",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "exec-btn",
                              onClick: ($event: any) => (props.downloadFile(file.id, index)),
                              loading: props.isDownloadings[index]
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.downloadBtn')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              color: "red",
                              rounded: "xl",
                              variant: "text",
                              onClick: ($event: any) => (props.deleteRegisteredFile(index, file))
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            (isDisplayAddButton.value)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  class: "d-flex justify-end ml-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "mr-2",
                      color: "primary",
                      rounded: "xl",
                      variant: "text",
                      onClick: addColumn
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})